"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _JobRunDetailViewRun2 = _interopRequireDefault(require("./__generated__/JobRunDetailViewRun.graphql"));
var React = _interopRequireWildcard(require("react"));
var _reactRelay = require("react-relay");
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DetailGrid = _interopRequireDefault(require("web/shared/jobs/DetailGrid"));
var _JobLogView = _interopRequireDefault(require("web/shared/jobs/JobLogView"));
var _instants = require("web/shared/jobs/instants.js");
var _runStates = require("web/shared/jobs/runStates.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _logBlockStyles = require("web/shared/jobs/logBlock.styles.js");
var _DetailGridStyles = require("web/shared/jobs/DetailGrid.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One attempt of a job: what it did, how long it took, and everything it logged.
*
* The suspending half of its page: it reads on render, so the loading and the
* failure lines belong to the frame above rather than to state here. A null
* answer is an ordinary one — a stale link reaches this page — and is said
* here rather than raised.
*/ // Runs and dispatches are fetched by their display number, which is what the
// operator sees everywhere and what the console's urls carry.
const DOCUMENT = _JobRunDetailViewRun2.default; /**
                                                * One recorded log line from a run or a dispatch.
                                                *
                                                * Derived from this read rather than written out: the dispatch detail selects
                                                * the same lines and its answer is read as this type, so the two selections
                                                * cannot drift apart without failing where the log view reads them.
                                                */ /** Everything recorded about the attempt, in the order it is asked about. */
function detailRows(run) {
  var _run$retryOfRunId;
  return [{
    label: "Job",
    value: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      to: "/internal/jobs/job/".concat(run.jobKey)
    }, stylex.props(_DetailGridStyles.styles.detailValue)), {}, {
      children: run.jobKey
    }))
  }, {
    label: "State",
    value: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, (0, _runStates.runStateStyle)(run.state))), {}, {
      children: run.state.toLowerCase()
    }))
  }, {
    label: "Date",
    value: (0, _instants.formatDate)(run.startedAt)
  }, {
    label: "Started",
    value: (0, _instants.formatTime)(run.startedAt)
  }, {
    label: "Ended",
    value: (0, _instants.formatTime)(run.finishedAt)
  }, {
    label: "Duration",
    value: (0, _instants.formatDuration)(run.startedAt, run.finishedAt)
  }, {
    label: "Dispatch",
    value: run.sequentialDispatchId == null ? "—" : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      to: "/internal/jobs/dispatch/".concat(String(run.sequentialDispatchId))
    }, stylex.props(_DetailGridStyles.styles.detailValue)), {}, {
      children: ["#", String(run.sequentialDispatchId)]
    }))
  }, {
    label: "Retry of",
    value: (_run$retryOfRunId = run.retryOfRunId) !== null && _run$retryOfRunId !== void 0 ? _run$retryOfRunId : "—"
  }, {
    label: "OS process",
    value: run.osProcessPid == null ? "—" : String(run.osProcessPid)
  }, {
    label: "DB backend",
    value: run.dbBackendPid == null ? "—" : String(run.dbBackendPid)
  }, {
    label: "Run id",
    value: run.runId
  }];
}
function JobRunDetailView(props) {
  const data = (0, _reactRelay.useLazyLoadQuery)(DOCUMENT, {
    runNumber: props.number
  }, {
    fetchKey: props.reloadKey,
    fetchPolicy: "network-only"
  });
  const detailRecord = data.internalJobRun;
  const run = detailRecord == null ? null : detailRecord.run;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: detailRecord == null || run == null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.statusNeutral)), {}, {
      children: ["No run #", props.label, " for this product."]
    })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailGrid.default, {
        rows: detailRows(run)
      }), run.error != null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.subHeading)), {}, {
          children: "failure"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.errorText)), {}, {
          children: run.error
        })), run.stackTrace != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_logBlockStyles.styles.logBlock)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_logBlockStyles.styles.logLine)), {}, {
            children: run.stackTrace
          }))
        })) : null]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.subHeading)), {}, {
        children: "log"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_JobLogView.default, {
        logs: detailRecord.logs,
        emptyMessage: "This run recorded no log lines."
      })]
    })
  });
}
var _default = exports.default = JobRunDetailView;